import numeral from 'numeral';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../../utils/default-lang';
import { BodyText, HeadingThree, SmallText } from '../../../typography';
import { BannerMainStatsSC, TooltipSC } from '../../investor-dash-banner.styled';
import CardSwitch from '../card-switch';

const DashBannerDesktop = ({
  dashboardData,
  handleEvaluationToggle,
  handleReinvestToggle,
  evaluationToggle,
  reinvestToggle,
  reinvest,
  redirectToInvestChange,
  evaluationValue1,
  evaluationValue2,
  evaluationPercentage1,
  evaluationPercentage2,
  reinvestValue1,
  reinvestValue2,
  reinvestPercentage,
}) => {
  return (
    <div className="main-stats-wrapper">
      <div className="left-inner-wrapper">
        <BodyText className="grey bolder">
          <span className="with-tooltip">
            <FormattedMessage
              id="investor_dash_banner_interest_label"
              defaultMessage={dlt['investor_dash_banner_interest_label']}
            />
            <TooltipSC
              contentId="investor_dash_banner_interest_label_tooltip"
              marginTop="2px"
              overlayInnerStyle={{ maxHeight: '100px', maxWidth: '600px' }}
              align={{ offset: [1, -5] }}
            />
          </span>
        </BodyText>
        <BannerMainStatsSC>
          <div
            className={`col evaluation ${
              evaluationValue1.length > 10 || evaluationValue2.length > 10 ? 'long-number' : ''
            }`}
          >
            <div className="toggle-wrapper">
              <CardSwitch>
                <>
                  <button
                    className={evaluationToggle === 'first' ? 'active' : ''}
                    onClick={() => handleEvaluationToggle('first')}
                  >
                    <FormattedMessage
                      id="investor_dash_banner_interest_actual"
                      defaultMessage={dlt['investor_dash_banner_interest_actual']}
                    />
                  </button>
                  <button
                    className={evaluationToggle === 'second' ? 'active' : ''}
                    onClick={() => handleEvaluationToggle('second')}
                  >
                    <FormattedMessage
                      id="investor_dash_banner_interest_expected"
                      defaultMessage={dlt['investor_dash_banner_interest_expected']}
                    />
                  </button>
                </>
              </CardSwitch>
            </div>
            <div className="col-content">
              <HeadingThree className="green">
                {evaluationToggle === 'first' ? evaluationValue1 : evaluationValue2} €
              </HeadingThree>
              <SmallText className="green">
                {evaluationToggle === 'first' ? evaluationPercentage1 : evaluationPercentage2}
              </SmallText>
            </div>
          </div>
        </BannerMainStatsSC>
      </div>
      <div className="left-inner-wrapper">
        <BodyText className="grey bolder">
          <span className="with-tooltip">
            <FormattedMessage
              id="investor_dash_banner_invested_label"
              defaultMessage={dlt['investor_dash_banner_invested_label']}
            />
            <TooltipSC
              contentId="investor_dash_banner_invested_label_tooltip"
              marginTop="2px"
              overlayInnerStyle={{ maxHeight: '100px', maxWidth: '600px' }}
              align={{ offset: [0, -5] }}
            />
          </span>
        </BodyText>
        <BannerMainStatsSC>
          <div
            className={`col evaluation ${
              reinvestValue1.length > 10 || reinvestValue2.length > 10 ? 'long-number' : ''
            }`}
          >
            <div className="toggle-wrapper">
              <CardSwitch>
                <>
                  <button
                    className={reinvestToggle === 'first' ? 'active' : ''}
                    onClick={() => handleReinvestToggle('first')}
                  >
                    <FormattedMessage
                      id="investor_dash_banner_invested_own"
                      defaultMessage={dlt['investor_dash_banner_invested_own']}
                    />
                  </button>
                  <button
                    className={reinvestToggle === 'second' ? 'active' : ''}
                    onClick={() => handleReinvestToggle('second')}
                  >
                    <FormattedMessage
                      id="investor_dash_banner_invested_paid_principals"
                      defaultMessage={dlt['investor_dash_banner_invested_paid_principals']}
                    />
                  </button>
                </>
              </CardSwitch>
            </div>
            <div className="col-content">
              <HeadingThree className="white">
                {reinvestToggle === 'first' ? reinvestValue1 : reinvestValue2} €
              </HeadingThree>
              <SmallText className="white">
                {/* Temporary hidden */}
                {/* {reinvestToggle === 'first' ? reinvestPercentage : <>&nbsp;</>} */}
                &nbsp;
              </SmallText>
            </div>
          </div>
        </BannerMainStatsSC>
      </div>
      <div className="right-inner-wrapper">
        <div className="right-wrap--top-infos">
          <div className="right-wrap--top-infos__reinvest-switch">
            {reinvest !== undefined ? (
              <button
                className={
                  reinvest === 'fully-reinvested'
                    ? 'green'
                    : reinvest === 'not-reinvested'
                    ? 'red'
                    : ''
                }
                onClick={() => redirectToInvestChange()}
              >
                <FormattedMessage id="global_reinvest" defaultMessage={dlt['global_reinvest']} />{' '}
                {dashboardData.reinvestRate ? (dashboardData.reinvestRate * 100).toFixed(0) : 0} %
              </button>
            ) : null}
          </div>
        </div>
        <BannerMainStatsSC className="active banner-right">
          <>
            <div
              className={`col ${
                numeral(Number(dashboardData.balance.free)).format('0,00.00').length > 10
                  ? 'long-number'
                  : ''
              }`}
            >
              <SmallText className="grey">
                <span className="with-tooltip">
                  <FormattedMessage
                    id="investor_dash_banner_waiting_label"
                    defaultMessage={dlt['investor_dash_banner_waiting_label']}
                  />
                  <TooltipSC
                    contentId="investor_dash_banner_waiting_label_tooltip"
                    placement="topRight"
                    overlayInnerStyle={{ maxHeight: '100px', maxWidth: '250px' }}
                    align={{ offset: [36, -5] }}
                  />
                </span>
              </SmallText>
              <div className="col-content">
                <HeadingThree className="dark-grey">
                  {numeral(Number(dashboardData.balance.free)).format('0,00.00')} €
                </HeadingThree>
              </div>
            </div>
          </>

          <div
            className={`col ${
              numeral(Number(dashboardData.balance.tied)).format('0,00.00').length > 10
                ? 'long-number'
                : ''
            }`}
          >
            <SmallText className="grey">
              <span className="with-tooltip">
                <FormattedMessage
                  id="investor_dash_banner_not_in_use_label"
                  defaultMessage={dlt['investor_dash_banner_not_in_use_label']}
                />
                <TooltipSC
                  contentId="investor_dash_banner_not_in_use_label_tooltip"
                  placement="topRight"
                  overlayInnerStyle={{ maxWidth: '300px' }}
                  align={{ offset: [43, -5] }}
                />
              </span>
            </SmallText>
            <HeadingThree className="white">
              {numeral(Number(dashboardData.balance.tied)).format('0,00.00')} €
            </HeadingThree>
          </div>
        </BannerMainStatsSC>
      </div>
    </div>
  );
};

export default DashBannerDesktop;
